var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "qm-picture-library" },
    [
      _vm.viewType === "dialog"
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "",
                "append-to-body": _vm.appendToBody,
                "close-on-click-modal": false,
                visible: _vm.visible,
                "custom-class": "qm-picture-library-dialog",
              },
              on: { close: _vm.closeDialog },
            },
            [
              _c(
                "Panel",
                _vm._g(
                  _vm._b(
                    {
                      attrs: {
                        appendToBody: _vm.appendToBody,
                        visible: _vm.visible,
                      },
                    },
                    "Panel",
                    _vm.$attrs,
                    false
                  ),
                  _vm.$listeners
                )
              ),
            ],
            1
          )
        : _vm.viewType === "panel"
        ? _c(
            "Panel",
            _vm._g(
              _vm._b(
                {
                  staticClass: "qm-picture-library-panel",
                  attrs: {
                    appendToBody: _vm.appendToBody,
                    visible: true,
                    showInsertBtn: false,
                  },
                },
                "Panel",
                _vm.$attrs,
                false
              ),
              _vm.$listeners
            )
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }